import { render, staticRenderFns } from "./ReasignacionOperaciones.vue?vue&type=template&id=2151817c&"
import script from "./ReasignacionOperaciones.vue?vue&type=script&lang=js&"
export * from "./ReasignacionOperaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports